// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__5JWBY","title":"Projects_title__szDrl","projects":"Projects_projects__CVx+a"};